import '../chart_view.js.coffee';# Added by Script 
import './pie_chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.StatusChartView extends Monitoring.Views.Charts.ChartView
  template: JST["backbone/templates/monitoring/charts/status_chart"]
  className: 'item status-chart w2'
  title: 'Approved vs. Rejected'
  title_en: 'Approved vs. Rejected'

  events:
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facets = @options.facets
    @_settings = @options.settings
    @container = @options.container

  render: () ->
    approved = _.find(@facets['status']['terms'], (status) -> return status.term == 'APPROVED')
    rejected = _.find(@facets['status']['terms'], (status) -> return status.term == 'REJECTED')
    approved = if approved then approved.count else 0
    rejected = if rejected then rejected.count else 0
    total = approved + rejected
    if total > 0
      approved = Math.round(approved * 100 / total)
      rejected = Math.round(rejected * 100 / total)
    @$el.html(@template({
      approved: approved,
      rejected: rejected,
      title: @title

    }))
    @trigger('masonry')
    return this
